<template>
  <a :href="$ComDomain.Modules.message" class="message-tip">
    <Badge :count="messageCount">
      <Icon type="ios-mail-outline" size="22" />
    </Badge>
  </a>
</template>
<script>
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { Icon, Badge } from 'iview'

export default {
  name: 'MessageTip',
  data() {
    return {
      timer: null,
      websock: null,
      stompClient: null,
      messageCount: 0
    }
  },
  watch: {
    '$store.state.messageList': {
      handler(value) {
        this.messageCount = this.$store.state.messageList.filter(msg => {
          return msg.msgStatus === 0
        }).length
      },
      deep: true
    }
  },
  methods: {
    connection() {
      // 初始化websocket
      this.websock = new SockJS(global.$ComDomain.Message.endpoint + '?token=' + this.$store.state.token)
      this.stompClient = Stomp.over(this.websock)
      this.stompClient.connect({}, frame => {
        this.stompClient.subscribe(global.$ComDomain.Message.subscribe, greeting => {
          this.$store.commit('getMessageList')
        })
      })
    },
    disconnect() {
      if (this.stompClient != null) {
        this.stompClient.disconnect()
      }
    }
  },
  created() {
    this.connection()
    // 断开重连机制，尝试发送消息，捕获异常发生时重连
    this.timer = setInterval(() => {
      try {
        if (!this.stompClient || this.stompClient.readyState !== 1) {
          this.disconnect();
          return;
        }
        this.stompClient.send('test')
      } catch (err) {
        this.connection()
      }
    }, 5000)
    this.$store.commit('getMessageList')
  },
  beforeDestroy() {
    this.disconnect()
    clearInterval(this.timer)
  },
  components: {
    Icon,
    Badge
  }
}

</script>
<style scoped lang="less">
.message-tip {
  margin-left: 0.5em;
  color: #fff;

  i {
    margin-top: -2px;
  }

  sup {
    min-width: 16px;
    height: 16px;
    line-height: 14px;
    padding: 0 4px 0 2px;
    top: 16px;
    right: 2px;
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/layout/MessageTip.vue